import { Typography } from '@speeki/global-ui-components';
import { IconManagerProps } from '@speeki/icons';

import {
    ActionWrapper,
    ArrowIcon,
    Divider,
    ProfileItemWrapper,
    StyledIcon,
} from './ProfileItem.styled';

interface ProfileItemProps {
    actionName: string;
    icon: IconManagerProps['icon'];
    isArrow?: boolean;
    isMobile?: boolean;
    isTopDivider?: boolean;
    onClick?: () => void;
    testId: string;
}

export const ProfileItem = ({
    actionName,
    icon,
    isArrow,
    isMobile,
    isTopDivider,
    onClick,
    testId,
}: ProfileItemProps) => {
    return (
        <ProfileItemWrapper data-testid={testId} onClick={onClick}>
            {isTopDivider && <Divider isMobile={isMobile} />}
            <ActionWrapper>
                <StyledIcon icon={icon} isMobile={isMobile} size={24} />
                {isMobile ? (
                    <Typography.TextBody_14_20>
                        {actionName}
                    </Typography.TextBody_14_20>
                ) : (
                    <Typography.TextBody_16_24>
                        {actionName}
                    </Typography.TextBody_16_24>
                )}

                {isArrow && (
                    <ArrowIcon
                        icon={'SvgChevronRight24'}
                        size={24}
                        themeColors={{
                            default: { 'color-1': 'text.secondary' },
                        }}
                    />
                )}
            </ActionWrapper>
        </ProfileItemWrapper>
    );
};
